/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'info': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" _stroke="#007FFF" stroke-width="2" cx="16" cy="16" r="15"/><path pid="1" _fill="#007FFF" d="M15 14h2v10h-2v-2z"/><circle pid="2" _fill="#007FFF" cx="16" cy="10.5" r="1.5"/></g>'
  }
})
